import { Notification } from "../../../entities/notification";
import NotificationRepository from './../../ports/notificationRepository';

export type addNotificationUseCase = (notification: Notification) => Promise<any>

export const buildNotification = (dependencies: {
  notificationRepo: NotificationRepository
}): addNotificationUseCase => {
  const { notificationRepo } = dependencies;

  const addNotification: addNotificationUseCase = async (notification: Notification) => 
    notificationRepo.addNotification(notification);

  return addNotification;
}